import { uniq, mergeWith } from 'lodash';

const parseFromSearch = (search) => {
  if (!search || search.length === 0) return {};

  const params = new URLSearchParams(search);
  const pairs = [];

  params.forEach((value, key) => {
    const match = key.match(/^channels\[(.+?)\]$/);
    if (!match) return;
    const eventId = match[1];
    const entries = (value || '').split(',').map(s => s.trim()).filter(Boolean);
    pairs.push([eventId, entries]);
  });

  return pairs.reduce((acc, [eventId, entries]) => {
    acc[eventId] = uniq([...(acc[eventId] || []), ...entries]);
    return acc;
  }, {});
};

export const readChannelsByEvent = (promoCode = null) => {
  try {
    const effectiveSearch = ((typeof window !== 'undefined' && window.location && window.location.search) ? window.location.search : '');

    if (!effectiveSearch) return (promoCode && promoCode.channel_keys_by_event) ? promoCode.channel_keys_by_event : {};

    const fromUrl = parseFromSearch(effectiveSearch);
    const fromPromo = (promoCode && promoCode.channel_keys_by_event) ? promoCode.channel_keys_by_event : {};

    return mergeWith({}, fromUrl, fromPromo, (a, b) => uniq([...(a || []), ...(b || [])]));
  } catch (_e) {
    return (promoCode && promoCode.channel_keys_by_event) ? promoCode.channel_keys_by_event : {};
  }
};

export const channelsForEvent = (eventId, promoCode = null) => {
  const merged = readChannelsByEvent(promoCode);
  const specific = (eventId && merged[eventId]) ? merged[eventId] : [];
  const combined = [...specific, 'NO_CHANNEL'];
  return Array.from(new Set(combined));
};


